/**
 * Where a Recent row points (M4 · 86d44z223).
 *
 * ⚠️ **THERE IS NO UNIFORM `/x/:id` IN THIS APP.** Quotations and sales orders live on WORKSPACE
 * pages addressed by a `?id=` query parameter; the picklist detail route is SINGULAR while its nav
 * href is plural; and the document viewer sits on a separate `/d/:docNo` root keyed by document
 * NUMBER, not an integer id. A naive `/${type}/${id}` builder looks right and dead-ends four of the
 * seven kinds. Same hazard, same shape as `notifications/lib/entityHref.ts`.
 *
 * Verified against `src/router/index.tsx` (2026-08-26): `/mro/issuance/picklist/:id` (:235),
 * `/mro/issuance/mrs/:id` (:234), `/mro/purchase-orders/:id` (:212), `/mro/receiving/:id` (:214),
 * `/quotations/workspace` (:189), `/sales-orders/workspace` (:203), `/d/:docNo` (:161).
 *
 * ⛔ Keys MUST match `RecentRecordKinds` in CSC_CORE — they are a persisted wire format.
 */
const ROUTES: Record<string, (id: string) => string> = {
  picklist: (id) => `/mro/issuance/picklist/${encodeURIComponent(id)}`,
  mrs: (id) => `/mro/issuance/mrs/${encodeURIComponent(id)}`,
  'purchase-order': (id) => `/mro/purchase-orders/${encodeURIComponent(id)}`,
  receiving: (id) => `/mro/receiving/${encodeURIComponent(id)}`,
  quotation: (id) => `/quotations/workspace?id=${encodeURIComponent(id)}`,
  'sales-order': (id) => `/sales-orders/workspace?id=${encodeURIComponent(id)}`,
  document: (docNo) => `/d/${encodeURIComponent(docNo)}`,
};

/**
 * The record a Recent row points at, or `null` when there is nowhere honest to send someone.
 *
 * ⛔ Returns null rather than guessing. An unknown kind means the server's vocabulary grew ahead of
 * this client, and a fabricated URL would land the user on a 404 that reads as "the record was
 * deleted". The caller drops the row instead.
 */
export function recentHref(entityType: string, entityId: string): string | null {
  const build = ROUTES[entityType];
  return build ? build(entityId) : null;
}
